import gql from 'graphql-tag'
export default gql`
query UserContacts ($value: Value) {
    UserContacts: Contacts(valueKey:"contactDetails", value:$value) {
        id
        personID
        contactDetails
      }
    }
  `
